import ConfirmarExclusao from '@/global/guides/Dialog/ConfirmarExclusao'
import { useTrocaAutomaticaHorarioOutletContext } from '@/pages/TrocaAutomaticaHorario.context'
import { trocaHorario } from '@/service/api'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

export default function ExcluirTrocaAutomaticaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaAutomaticaHorarioOutletContext()
    const item = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } =
        trocaHorario.trocaAutomatica.mutations.useDelete({
            invalidateQuery: true,
        })

    if (!item) return null

    const handleSubmit = () =>
        mutateAsync(item.id, {
            onSuccess: () => {
                toast.success('Troca automática excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'TrocaAutomáticaDeHorário']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir a troca automática de horário de{' '}
                    {item.Funcionario?.nome}?
                </>
            }
        />
    )
}
